import type { Sprite } from './ConfettiGeyser.types';

const DEFAULT_SPRITES: Array<Sprite> = [
  {
    src: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTEiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCA1MSAxOCIgZmlsbD0ibm9u%0D%0AZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQ3LjQ3MDYg%0D%0AM0wzOC41NzY1IDE0LjExNzZMMjkuNjgyMyAzTDIwLjc4ODIgMTQuMTE3NkwxMS44OTQxIDIuOTk5%0D%0AOTlMMi45OTk5OSAxNC4xMTc2IiBzdHJva2U9IiM5RTNFRkYiIHN0cm9rZS13aWR0aD0iNiIgc3Ry%0D%0Ab2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=',
    width: 51,
    height: 18,
    airFrictionMultiplier: 0.75,
  },
  {
    src: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxMiAxOCIgZmlsbD0ibm9u%0D%0AZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjEyIiBo%0D%0AZWlnaHQ9IjE4IiBmaWxsPSIjNUE3RkZGIi8+Cjwvc3ZnPgo=',
    width: 12,
    height: 18,
    airFrictionMultiplier: 1.2,
  },
  {
    src: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9u%0D%0AZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iOCIgY3k9%0D%0AIjgiIHI9IjgiIGZpbGw9IiNGRjQwMkUiLz4KPC9zdmc+Cg==',
    width: 16,
    height: 16,
    airFrictionMultiplier: 1.15,
  },
  {
    src: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMiAyMSIgZmlsbD0ibm9u%0D%0AZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMuNTI5NDIg%0D%0AMThMMTguMzUyOSAzLjE3NjQ1TTMuNTI5NDIgMy4xNzY0NUwxMC45NDEyIDEwLjU4ODJMMTguMzUy%0D%0AOSAxOCIgc3Ryb2tlPSIjRkZFQjMzIiBzdHJva2Utd2lkdGg9IjYiIHN0cm9rZS1saW5lY2FwPSJy%0D%0Ab3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K',
    width: 20,
    height: 20,
    airFrictionMultiplier: 0.9,
  },
  {
    src: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMiAyMSIgZmlsbD0ibm9u%0D%0AZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMuNTQzOTcg%0D%0AMTcuNDExMUMzLjE4NjY4IDE1LjQ0NzkgMy4zMzIwOSAxMy40MjYxIDMuOTY2NjYgMTEuNTM0MkM0%0D%0ALjYwMTIyIDkuNjQyMzEgNS43MDQzIDcuOTQxNzkgNy4xNzMxNCA2LjU5MTA1QzguNjQxOTggNS4y%0D%0ANDAzMSAxMC40Mjg4IDQuMjgzMyAxMi4zNjcxIDMuODA5MTdDMTQuMzA1NSAzLjMzNTAzIDE2LjMz%0D%0AMjMgMy4zNTkyIDE4LjI1ODggMy44Nzk0MiIgc3Ryb2tlPSIjMzJGRjk4IiBzdHJva2Utd2lkdGg9%0D%0AIjYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2%0D%0AZz4K',
    width: 16,
    height: 14,
    airFrictionMultiplier: 1,
  },
  {
    src: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzMiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAzMyAxOCIgZmlsbD0ibm9u%0D%0AZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI5LjY4MjQg%0D%0AM0wyMC43ODgzIDE0LjExNzZMMTEuODk0MSAzTDMuMDAwMDIgMTQuMTE3NiIgc3Ryb2tlPSIjRkYy%0D%0AN0ZGIiBzdHJva2Utd2lkdGg9IjYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVq%0D%0Ab2luPSJyb3VuZCIvPgo8L3N2Zz4K',
    width: 33,
    height: 18,
    airFrictionMultiplier: 0.8,
  },
];

export default DEFAULT_SPRITES;
